export const orderColumns = [
    {
        column:"webshopreference",
        required:true,
    },
    {
        column:"Geplande datum",
        required:true,
    },
    {
        column:"pickup_order",
        required:false,
    },
    {
        column:"b2b_order",
        required:false,
    },

    {
        column:"firstname",
        required:true,
    },
    {
        column:"lastname",
        required:true,
    },
    {
        column:"Bedrijf",
        required:false,
    },
    {
        column:"phone",
        required:false,
    },
    {
        column:"email",
        required:false,
    },
    {
        column:"address1",
        required:true,
    },
    {
        column:"address2",
        required:false,
    },
    {
        column:"postal",
        required:true,
    },
    {
        column:"city",
        required:true,
    },
    {
        column:"country_of_origin",
        columnExplainer:"2-letterige landcode",
        required:false,
    },
    {
        column:"sku",
        required:true,
    },
    {
        column:"amount",
        required:true,
    },
]

export const inboundRelationColums = [
    {
        column:"inb_reference",
        required:true,
    },
    {
        column:"inb_sku",
        required:true,
    },
    {
        column:"inb_expected_amount",
        required:true,
    },
    {
        column:"inb_leverancier",
        required:false,
    },
]

export const inboundFulfilmentColums = [
    {
        column:"inb_warehouse",
        columnExplainer:"Verplicht wanneer je meerdere magazijnen in jouw omgeving hebt",
        required:true,
    },
    {
        column:"inb_warehouselocation",
        columnExplainer:"Verplicht wanneer je een ontvangen aantal wilt registreren op een bestaande inslag",
        required:true,
    },
    {
        column:"inb_customer",
        required:true,
    },
    {
        column:"inb_reference",
        columnExplainer:"Verplicht bij een nieuwe inslag",
        required:true,
    },
    {
        column:"inb_inbound",
        columnExplainer:"Verplicht wanneer je een ontvangen aantal wilt registreren op een bestaande inslag. Wanneer je deze kolom hebt gevuld, moet je de kolom 'Referentie' niet aan het bestand toevoegen",
        required:true,
    },
    {
        column:"inb_sku",
        required:true,
    },
    {
        column:"inb_expected_amount",
        required:true,
    },
    {
        column:"inb_received",
        columnExplainer:"Verplicht wanneer je de voorraad direct op een locatie wilt boeken",
        required:true,
    },
    {
        column:"inb_leverancier",
        required:false,
    },
]
